











  import { HistoryQuery } from '@empathyco/x-types';
  import Vue from 'vue';
  import { Component, Prop } from 'vue-property-decorator';
  import BaseEventButton from '../../../components/base-event-button.vue';
  import { xComponentMixin } from '../../../components/x-component.mixin';
  import { XEventsTypes } from '../../../wiring/events.types';
  import { historyQueriesXModule } from '../x-module';

  /**
   * Button that when it is pressed emits the
   * {@link HistoryQueriesXEvents.UserPressedRemoveHistoryQuery} event, expressing the user
   * intention to remove a query in the history.
   *
   * @public
   */
  @Component({
    components: { BaseEventButton },
    mixins: [xComponentMixin(historyQueriesXModule)]
  })
  export default class RemoveHistoryQuery extends Vue {
    /**
     * The historyQuery that will be removed when clicking the clear button.
     *
     * @public
     */
    @Prop({ required: true })
    protected historyQuery!: HistoryQuery;

    /**
     * The event handler that will be triggered when clicking on the clear history query button.
     *
     * @remarks
     * {@link HistoryQueriesXEvents.UserPressedRemoveHistoryQuery}: historyQuery
     *
     * @returns The {@link XEvent} to emit.
     * @public
     */
    protected get removeHistoryQueryEvent(): Partial<XEventsTypes> {
      return { UserPressedRemoveHistoryQuery: this.historyQuery };
    }
  }
